import GateKeeperMiddleware from '@/middleware/GateKeeperMiddleware.js';

export default [
    {
        name: 'course-attempt-authorizations-view',
        path: '/courses/:courseId/attempt-authorizations',
        component: () => import('@/pages/courses/attempt-authorizations/AttemptAuthorizationsIndex.vue'),
        props: route => ({
            courseId: Number.parseInt(route.params.courseId, 10),
        }),
        meta: {
            title: 'Attempt Authorizations',
            middleware: [GateKeeperMiddleware],
            ability: { action: 'view all', subject: 'attempt authorizations' },
        },
    },
];
